import React, { useEffect, useState } from "react";
import { X } from "lucide-react";

const visionPoints = [
  "Promote Economic Activities through provision of Concessional Finance.",
  "Promote Developmental activities primarily through: Marketing Support & Awareness/Advocacy Programmes",
];

const financialSchemes = [
  "Term Loan Scheme",
  "Educational Loan Scheme",
  "Virasat Scheme",
  "Micro Financing Scheme",
];

const servicePoints = [
  'To promote economic and developmental activities for the benefits of "Backward sections" amongst the minorities, preference being given to occupational groups and women.,',
  "To assist, subject to such income and/or economic criteria as may be prescribed by the Government from time to time, the Minorities individuals or groups of Minorities individuals by way of loans and advances for economically and financially viable schemes and projects; under micro financing scheme, group of individuals belonging to the minorities will include such groups in which predominantly (75% and above) members belongs to minority community. In very exceptional cases this may include those group also where upto 60% members belong to minority community provided other members belong to Weaker sections including Scheduled castes/scheduled tribes, other backward classes and disabled. (as per the EGM held on 1.11.1999 and CG approval vide letter 3/17/T-1/2000/D/8278 dated 9.2.2000).",
  "To promote self-employment and other ventures for the benefit of minorities.",
  "To grant loans and advances at such rates of interest as may be determined from time to time in accordance with the guidelines or schemes prescribed by the Central Government or by the Reserve Bank of India;",
  "To extend loans and advances to the eligible members belonging to the minorities for pursuing general/professional/technical education or training at graduate and higher level.",
  "To assist in the upgradation of technical and entrepreneurial skills of minorities for proper and efficient management of production",
  "To assist the state level organisations dealing with the development of the minorities by way of providing financial assistance or equity contribution and in obtaining commercial funding or by way of refinancing.",
  "To work as an apex institution for coordinating and monitoring the work of all corporations/boards/other bodies set up by the government/Union Territory Administrations for, or given the responsibility of assisting the minorities for their economic development; and",
  "To help in furthering the Government policies and programmes for the development of minorities.",
];

const monitoringPoints = [
  "Monitoring of SCAs - periodic verification of utilization certificates, progress reports received, detailed list of beneficiaries received.",
  "Monitoring of NGOs, pre and post sanction study physically by officers for this purpose.",
  "Impact Study",
  "Grievance redressal mechanism- CPGRAM",
];

const addressLines = [
  "Address of Registered office :",
  "SCOPE Minar, 1st Floor, Core 1, Laxmi Nagar, Delhi-110092",
  "Fax No: +91-11-22441452",
  "Phone No: +91-11-22441453/55/",
  "Web site : www.nmdfc.org",
  "Toll free no. 14402",
  "Mobile app on android and iOS.",
];

const organizationalSetupRows = [
  {
    name: "Shri Anil Kumar",
    designation: "Deputy General Manager (Proj. and L&R)/CVO",
    work:
      "Charge of CVO/ act as Appellate Authority and All work related to Project and L&R Div. such as Disbursement, Implementation of Marketing Assistance scheme, Organizing of Hunar Haat under Lok Samvardhan Parv & Other Exhibitions, and All Legal and Recovery matters,",
  },
  {
    name: "Shri Kumar Sudesh",
    designation: "Deputy General Manager (Finance and Coordination)",
    work:
      "All work related to Finance and Coordination Div. such as Processing of Salary, Tender Other than System & Admin, Disbursement, Monthly Progress Report, Work related to Parliament, Parliamentary Standing Committee, Consultative Committee, VIP references",
  },
  {
    name: "Shri Nixon Mathur",
    designation: "Deputy General Manager (Planning)/CS",
    work:
      "All work related to Planning and Company Secretary Div. such as Disbursement, CSR, seminars, Annual Action Plan & Annual Allocation, Company Affairs, Social Media",
  },
  {
    name: "Shri Manoj Punia",
    designation: "Deputy General Manager (Accounts)",
    work:
      "All work related to Accounts such as Accounts, Disbursement, Grants-in-Aid Scheme, E- Marketing, MoU / QPR, Audit, DPE related works.",
  },
  {
    name: "Shri P.S. Pawnikar",
    designation:
      "Deputy General Manager (HRM & Admin/Systems & Skill Development)",
    work:
      "All work related to System and Administration Div. such as all Hardware and Software related matters, MILAN Portal, IVRS/ Mobile app, Systems, Evaluation Study, Maintaining MIS Data, E-Samiksha, etc. work related to HRM cell, Rajbhasha works, Tender related to Admin Division",
  },
  {
    name: "Sh. Sachin Kumar",
    designation: "Assistant General Manager (Accounts)",
    work: "All work related to Accounts Division",
  },
  {
    name: "Sh. D. Das",
    designation: "Assistant General Manager (HRM & Admin)/ PIO",
    work: "Charge of PIO, All work related to HRM and Admin",
  },
  {
    name: "Sh. Jauedul Hasan",
    designation: "Assistant General Manager (Planning/L&R)",
    work: "All work related to Planning Division & L&R Division",
  },
  {
    name: "Sh. S.M. Jha",
    designation: "Deputy Manager (OL / Records Management)",
    work: "All Rajbhasha works. Charge of Record Officer",
  },
  {
    name: "Sh. Pradeep Kr. Gupta",
    designation: "Deputy Manager (L&R)",
    work: "All work related to Legal & Recovery",
  },
  {
    name: "Sh. Harish Sharma",
    designation: "Deputy Manager (Publicity & Social Media)",
    work: "All works related to Publicity and Social Media & Planning Division",
  },
  {
    name: "Sh. Vikas Khatri",
    designation: "Deputy Manager (Finance)/APIO",
    work: "All Work related to Finance Division, Charge of APIO",
  },
  {
    name: "Sh. Narendra Kumar Nitharwal",
    designation: "Deputy Manager (Accounts)",
    work: "All Work related to Accounts",
  },
  {
    name: "Sh. Rajan Yadav",
    designation: "Deputy Manager (Systems & Skill Development)",
    work: "All Work related to System Division",
  },
  {
    name: "Sh. Vinod Kumar Prajapati",
    designation: "Assistant Manager(IT)",
    work: "All Work related to IT section",
  },
  {
    name: "Sh. Vipin Nijhawan",
    designation: "Assistant Manager(Project/L&R)",
    work: "All work related to Legal & Recovery & Project Department",
  },
  {
    name: "Sh. Dharmender Kumar",
    designation: "Assistant Manager(Finance)",
    work: "All Work related to Finance Division",
  },
  {
    name: "Smt. Sharmeen Qureshi",
    designation: "Assistant Manager(Accounts)",
    work: "All Work related to Accounts",
  },
  {
    name: "Sh. Sushil Saini",
    designation: "Assistant Manager(Admin)",
    work: "All Work related to Admin & HRM",
  },
  {
    name: "Sh. Brij Mohan",
    designation: "Assistant Manager(CMD-Sectt)",
    work: "All works related to CMD sectt.",
  },
  {
    name: "Smt. Urmila Kumari",
    designation: "Assistant Manager(CS)",
    work: "All works related to CS section & Planning section",
  },
];

const Section = ({ title, children }) => (
  <section>
    <h3 className="mb-1 text-[15px] font-bold leading-6 text-[#123764]">
      {title}
    </h3>
    {children}
  </section>
);

const UnderlinedLabel = ({ children }) => (
  <p className="text-[14px] font-bold uppercase leading-6 text-[#123764] underline underline-offset-2">
    {children}
  </p>
);

const PdfBadge = () => (
  <span className="relative inline-block h-[15px] w-[13px] shrink-0 rounded-[2px] bg-[#e0e5ea] align-middle shadow-[0_1px_1px_rgba(0,0,0,0.18)]">
    <span className="absolute right-0 top-0 h-0 w-0 border-b-[5px] border-l-[5px] border-b-[#c5ced7] border-l-transparent" />
    <span className="absolute left-1/2 top-[7px] -translate-x-1/2 rounded-[1px] bg-[#ff5145] px-[2px] text-[5px] font-bold leading-[7px] text-white">
      PDF
    </span>
  </span>
);

const OrganizationalSetupModal = ({ onClose }) => {
  useEffect(() => {
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = originalOverflow;
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-[9000] flex items-center justify-center bg-black/35 px-4 py-6"
      onClick={onClose}
    >
      <section
        role="dialog"
        aria-modal="true"
        aria-labelledby="organizational-setup-title"
        className="flex h-[84vh] w-full max-w-[1050px] flex-col overflow-hidden rounded-[6px] bg-white shadow-[0_24px_80px_rgba(0,0,0,0.28)]"
        onClick={(event) => event.stopPropagation()}
      >
        <header className="flex shrink-0 items-center justify-between gap-4 border-b border-[#d7dde4] px-7 py-5">
          <h2
            id="organizational-setup-title"
            className="m-0 text-[20px] font-bold leading-7 text-[#006461]"
          >
            Organisational Setup of NMDFC
          </h2>

          <button
            type="button"
            onClick={onClose}
            aria-label="Close organisational setup"
            className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-[#123764] bg-white text-[#123764] transition-colors hover:bg-[#eef5ff] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#0f8a7e] focus-visible:ring-offset-2"
          >
            <X size={22} strokeWidth={1.8} />
          </button>
        </header>

        <div className="min-h-0 flex-1 overflow-y-auto px-7 pb-4 pt-2 text-[#001b33]">
          <div className="flex flex-col items-center pb-5 pt-1 text-center text-[16px] font-bold text-[#123764]">
            <p>Board of Directors</p>
            <span className="my-1 text-[38px] font-normal leading-none text-black">
              &darr;
            </span>
            <p>CMD</p>
            <span className="my-1 text-[38px] font-normal leading-none text-black">
              &darr;
            </span>
          </div>

          <div className="overflow-x-auto">
            <table className="w-full min-w-[840px] border-collapse text-[15px] leading-5">
              <thead>
                <tr className="bg-[#dce9fb] text-left text-[14px] font-bold text-[#001b33]">
                  <th className="rounded-l-[6px] px-5 py-4">
                    Name of the incumbent
                  </th>
                  <th className="px-5 py-4">Designation</th>
                  <th className="rounded-r-[6px] px-5 py-4">Work Assigned</th>
                </tr>
              </thead>
              <tbody>
                {organizationalSetupRows.map((row, index) => (
                  <tr
                    key={`${row.name}-${row.designation}`}
                    className={`border-b border-[#d7dde4] ${
                      index % 2 === 0 ? "bg-white" : "bg-[#f6f9fc]"
                    }`}
                  >
                    <td className="w-[23%] px-5 py-3.5 align-middle font-medium">
                      {row.name}
                    </td>
                    <td className="w-[28%] px-5 py-3.5 align-middle font-medium">
                      {row.designation}
                    </td>
                    <td className="px-5 py-3.5 align-middle font-medium">
                      {row.work}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </div>
  );
};

const ChapterTwoContent = () => {
  const [isSetupModalOpen, setIsSetupModalOpen] = useState(false);

  return (
    <>
      <article className="min-w-0 flex-1 space-y-4 px-1 pb-8 font-sans text-[14px] leading-6 text-[#123764]">
        <header>
          <h2 className="mb-2 text-[20px] font-bold leading-7 text-[#006461]">
            Chapter 2 : Organisation structure, functions and duties [SECTION
            4(1)(B)(i)]
          </h2>
          <UnderlinedLabel>Introduction</UnderlinedLabel>
        </header>

        <Section title="2.1 Objective/purpose of the public authority">
          <p>
            To promote economic and developmental activities for the benefit of
            the backward sections amongst the Minorities, preference being given
            to the occupational groups and women:
          </p>
        </Section>

        <Section title="2.2 Mission/Vision Statement of the public authority.">
          <p className="font-bold uppercase">Mission:</p>
          <p>Economic empowerment of weaker sections amongst Minorities.</p>
          <p className="mt-1 font-bold uppercase">Vision:</p>
          <ul className="ml-6 list-disc space-y-1">
            {visionPoints.map((point) => (
              <li key={point}>{point}</li>
            ))}
          </ul>
        </Section>

        <Section title="2.3 Brief history of the public authority and context of its formation">
          <p>
            NATIONAL MINORITIES DEVELOPMENT AND FINANCE CORPORATION (NMDFC) was
            incorporated as a Government Company, on September 30, 1994 under
            then Ministry of Welfare as a Company not for profit under Section
            25 of the Companies Act, 1956 (Now Section 8 under Companies Act,
            2013). NMDFC is working under the aegis of Ministry of Minority
            Affairs since 2006. As on date, Government of India and State
            Governments hold the entire equity share capital of the Company.
          </p>
        </Section>

        <Section title="2.4 Duties of the public authority.">
          <p>
            It is the duty of NMDFC to carry out the objectives mentioned in
            clause III.A of Memorandum of Association. Apart from this, in the
            functioning of the Company, it is also the duty of the Company to
            adhere to regulations contained in Memorandum & Articles of
            Association of the Company, and various norms, policies, guidelines
            issued by various Statutory Authorities, Department of Public
            Enterprises, Ministry of Minority Affairs, Government of India,
            Foreign Contribution Unit of Ministry of Home Affairs, Government of
            India.
          </p>
        </Section>

        <Section title="2.5 Main activities/functions of the public authority.">
          <UnderlinedLabel>
            Financial Assistance Schemes of NMDFC
          </UnderlinedLabel>
          <ol className="ml-5 list-decimal space-y-1">
            {financialSchemes.map((scheme) => (
              <li key={scheme}>{scheme}</li>
            ))}
          </ol>

          <UnderlinedLabel>Promotional Schemes</UnderlinedLabel>
          <ol className="ml-5 list-decimal space-y-1">
            <li>Marketing Assistance Scheme</li>
          </ol>

          <UnderlinedLabel>Grant In Aid Assistance Scheme</UnderlinedLabel>
        </Section>

        <Section title="2.6 List of services being provided by the public authority with a brief write-up on them">
          <ul className="ml-5 list-disc space-y-1">
            {servicePoints.map((point) => (
              <li key={point}>{point}</li>
            ))}
          </ul>
        </Section>

        <Section title="2.7 Organizational Structure Diagram at various levels namely State, Directorate, Region, District, Block etc. (whichever is applicable)">
          <button
            type="button"
            onClick={() => setIsSetupModalOpen(true)}
            className="inline-flex items-center gap-2 bg-transparent p-0 text-[#123764] underline underline-offset-2 hover:text-[#0f8a7e] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#0f8a7e] focus-visible:ring-offset-2"
          >
            Click here to open
            <PdfBadge />
          </button>
        </Section>

        <Section title="2.8 Expectation of the public authority from the public for enhancing its effectiveness and efficiency">
          <p>
            Under the various Schemes of lending / promotional schemes, the
            public namely the beneficiaries should follow all the procedures for
            availing the same
          </p>
        </Section>

        <Section title="2.9 Arrangements and methods made for seeking public participation/contribution">
          <p>
            Exhibitions and Fairs, Conferences, Seminars and Workshops being held
            at various places at India
          </p>
        </Section>

        <Section title="2.10 Mechanism available for monitoring the services delivery and public grievance resolution">
          <ol className="ml-5 list-[upper-roman] space-y-1">
            {monitoringPoints.map((point) => (
              <li key={point}>{point}</li>
            ))}
          </ol>
        </Section>

        <Section title="2.11 Addresses of the main office and other offices at different levels. (Please categories the addresses district wise for facilitating the understanding by the user)">
          <div className="space-y-1">
            {addressLines.map((line) => (
              <p key={line}>{line}</p>
            ))}
          </div>
        </Section>

        <Section title="2.12 Office hours">
          <div className="space-y-1">
            <p>Opening hours: 9:30 AM</p>
            <p>Closing hours: 6.00 PM</p>
            <p>(Monday to Friday)</p>
          </div>
        </Section>
      </article>

      {isSetupModalOpen && (
        <OrganizationalSetupModal onClose={() => setIsSetupModalOpen(false)} />
      )}
    </>
  );
};

export default ChapterTwoContent;